var _defs, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceModel1RectColleague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "patt1",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y: 0,
    x2: 0,
    y2: 24,
    stroke: "#d32f2f",
    strokeWidth: 28
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 100,
    x: 0,
    y: 0,
    rx: 15,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 100,
    x: 0,
    y: 0,
    rx: 15,
    stroke: "#d32f2f",
    fill: "url(#patt1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceModel1RectColleague);
export default __webpack_public_path__ + "static/media/place_model-1_rect_colleague.9be0bf0b11dd4c974b9fab5b8ff46448.svg";
export { ForwardRef as ReactComponent };